export const relayScheduleSelector = state => state.entities.relaySchedules;
